/* ==========================================================================
   ML · Mejoras UI/UX (BigStudio 2026-07-11) — capa GLOBAL, progresiva.
   Botón "volver arriba", CTA fija en móvil, resalte de sección activa en el
   menú y red de seguridad de reveals. Todo idempotente y tolerante a fallos.
   (Los sellos de prueba/garantía de los planes ahora se renderizan desde el
   editor en ml-planes.liquid — ya no se inyectan por JS.)
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.LANGFORD_HEADER || {};
  var CTA = CFG.cta || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isExternal(url) {
    return /^https?:\/\//i.test(url) && url.indexOf('metodolangford') === -1;
  }
  function pathOf(href) {
    try { return new URL(href, window.location.origin).pathname.replace(/\/+$/, ''); }
    catch (e) { return null; }
  }

  /* --- A) Botón volver arriba --- */
  function backToTop() {
    if (document.querySelector('.ml-backtotop')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ml-backtotop';
    b.setAttribute('aria-label', 'Volver arriba');
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    document.body.appendChild(b);
    var ticking = false;
    function toggle() {
      if (window.pageYOffset > 600) b.classList.add('is-visible');
      else b.classList.remove('is-visible');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(toggle);
    }, { passive: true });
    toggle();
  }

  /* --- B) CTA fija inferior en móvil --- */
  function mobileCta() {
    if (!CTA.url || CTA.enabled === false) return;
    if (window.matchMedia('(min-width: 750px)').matches) return;
    if (document.querySelector('.ml-mobilecta')) return;
    var bar = document.createElement('div');
    bar.className = 'ml-mobilecta';
    var a = document.createElement('a');
    a.className = 'ml-mobilecta__btn';
    a.href = CTA.url;
    a.textContent = CTA.label || 'Ir a la Plataforma';
    if (isExternal(CTA.url)) { a.target = '_blank'; a.rel = 'noopener'; }
    bar.appendChild(a);
    document.body.appendChild(bar);
    document.body.classList.add('ml-has-mobilecta');

    var zones = document.querySelectorAll('.mlfoot, #plans, .ml-plans');
    if ('IntersectionObserver' in window && zones.length) {
      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
        });
        if (visible.size) bar.classList.remove('is-shown');
        else bar.classList.add('is-shown');
      }, { rootMargin: '0px 0px -8% 0px' });
      zones.forEach(function (z) { io.observe(z); });
    }
    setTimeout(function () { bar.classList.add('is-shown'); }, 450);
  }

  /* --- C) Resalte de sección activa en el menú (item padre de la página) --- */
  function sectionActive() {
    var here = window.location.pathname.replace(/\/+$/, '');
    if (!here) return; // home: nada que resaltar
    var items = document.querySelectorAll('.header__inline-menu .header__menu-item');
    items.forEach(function (el) {
      var matched = false;
      var href = el.getAttribute('href');
      if (href) {
        var p = pathOf(href);
        if (p && (here === p || here.indexOf(p + '/') === 0)) matched = true;
      } else {
        var det = el.closest('details');
        if (det) {
          det.querySelectorAll('a[href]').forEach(function (a) {
            var cp = pathOf(a.getAttribute('href'));
            if (cp && (here === cp || here.indexOf(cp + '/') === 0)) matched = true;
          });
        }
      }
      if (matched) el.classList.add('ml-section-active');
    });
  }

  /* --- D) Red de seguridad: revelar reveals atascados que estén en viewport --- */
  function revealSafety() {
    setTimeout(function () {
      document.querySelectorAll('.scroll-trigger.scroll-trigger--offscreen').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) {
          el.classList.remove('scroll-trigger--offscreen');
        }
      });
    }, 2500);
  }

  function run() {
    try { backToTop(); } catch (e) {}
    // try { mobileCta(); } catch (e) {}  // DISABLED 2026-09-18: sticky mobile "Go to the Platform" bar removed — it duplicated the button already in the mobile menu (see langford-header-premium.js). Uncomment to re-enable.
    try { sectionActive(); } catch (e) {}
    try { revealSafety(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function () {
    try { sectionActive(); } catch (e) {}
  });
})();
